import React from 'react';
import InputSearch from './InputSearch';

import {
  Container,
  CheckBox,
  CheckBoxText,
  CheckBoxWrap,
  WrapButtons,
  ButtonDownload,
  ButtonEmail,
  Separator,
  WrapItems,
} from './styles';

function HeaderControls({
  selectedAll,
  setSelectedAll,
  showCheckBox,
  checkBoxTextValue,
  dowloadButton,
  emailButton,
  dowloadButtonText,
  emailButtonText,
  downloadAction,
  emailAction,
  selectedItemsNumber,
  isLoading,
  hasInpuSearch,
  setSearchValue,
  searchValue,
}) {
  return (
    <WrapItems>
      {hasInpuSearch && (
        <InputSearch
          setSearchValue={setSearchValue}
          searchValue={searchValue}
        />
      )}
      <Container>
        <CheckBoxWrap>
          {showCheckBox && (
            <CheckBox isChecked={selectedAll} setIsChecked={setSelectedAll} />
          )}
          {showCheckBox && checkBoxTextValue && (
            <CheckBoxText>{checkBoxTextValue}</CheckBoxText>
          )}
        </CheckBoxWrap>

        <WrapButtons>
          {dowloadButton && (
            <ButtonDownload
              disabled={isLoading || selectedItemsNumber === 0}
              buttonType={
                isLoading || selectedItemsNumber === 0 ? 'disabled' : 'outline'
              }
              onClick={downloadAction}
            >
              {isLoading ? 'Aguarde...' : dowloadButtonText}
            </ButtonDownload>
          )}
          {emailButton && (
            <ButtonEmail
              disabled={isLoading || selectedItemsNumber === 0}
              buttonType={
                isLoading || selectedItemsNumber === 0 ? 'disabled' : 'primary'
              }
              onClick={emailAction}
            >
              {isLoading ? 'Aguarde...' : emailButtonText}
            </ButtonEmail>
          )}
        </WrapButtons>
      </Container>
      <Separator />
    </WrapItems>
  );
}

export default HeaderControls;
